/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { LinkedAppointmentOptions } from './LinkedAppointmentOptions';
import {
    LinkedAppointmentOptionsFromJSON,
    LinkedAppointmentOptionsFromJSONTyped,
    LinkedAppointmentOptionsToJSON,
} from './LinkedAppointmentOptions';

/**
 *  Link to other appointment with options, when is_main is falsy  the other properties refer to the linked appointment when is_main is true  the other properties refer to this appointment 
 * @export
 * @interface LinkedAppointment
 */
export interface LinkedAppointment {
    /**
     * 
     * @type {string}
     * @memberof LinkedAppointment
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof LinkedAppointment
     */
    date: number;
    /**
     * Is main appointment?
     * @type {boolean}
     * @memberof LinkedAppointment
     */
    is_main?: boolean;
    /**
     * 
     * @type {LinkedAppointmentOptions}
     * @memberof LinkedAppointment
     */
    options?: LinkedAppointmentOptions;
}

/**
 * Check if a given object implements the LinkedAppointment interface.
 */
export function instanceOfLinkedAppointment(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "date" in value;

    return isInstance;
}

export function LinkedAppointmentFromJSON(json: any): LinkedAppointment {
    return LinkedAppointmentFromJSONTyped(json, false);
}

export function LinkedAppointmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): LinkedAppointment {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'date': json['date'],
        'is_main': !exists(json, 'is_main') ? undefined : json['is_main'],
        'options': !exists(json, 'options') ? undefined : LinkedAppointmentOptionsFromJSON(json['options']),
    };
}

export function LinkedAppointmentToJSON(value?: LinkedAppointment | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'date': value.date,
        'is_main': value.is_main,
        'options': LinkedAppointmentOptionsToJSON(value.options),
    };
}

